<template>
  <div>
    <el-button type="danger" @click="addeletedialogVisible = true" round >生成蓝牙激活码</el-button>
    <el-dialog
        title="提示"
        :visible.sync="addeletedialogVisible"
        width="30%">
      <span>此操作会生成200个激活码并存库，确定生成吗？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="addeletedialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="downloadRepCheckReport()">
      确认生成
    </el-button>
  </span>
    </el-dialog>

    <el-button type="danger" @click="tempaddeletedialogVisible = true" round >生成蓝牙体验激活码</el-button>
    <el-dialog
        title="提示"
        :visible.sync="tempaddeletedialogVisible"
        width="30%">
      <span>此操作会生成200个临时激活码并存库，确定生成吗？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="tempaddeletedialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="tempdownloadRepCheckReport()">
      确认生成
    </el-button>
  </span>
    </el-dialog>

    <el-button type="danger" @click="wifiaddeletedialogVisible = true" round >生成WIFI激活码</el-button>
    <el-dialog
        title="提示"
        :visible.sync="wifiaddeletedialogVisible"
        width="30%">
      <span>此操作会生成200个激活码并存库，确定生成吗？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="wifiaddeletedialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="downloadRepCheckReportwifi()">
      确认生成
    </el-button>
  </span>
    </el-dialog>


  </div>

</template>

<script>
import axios from "@/axios";

export default {
  data() {
    return {
      addeletedialogVisible:false,
      tempaddeletedialogVisible:false,
      wifiaddeletedialogVisible:false,
      wifitempaddeletedialogVisible:false,
    }
  },

  methods: {
    downloadRepCheckReport() {
      this.addeletedialogVisible = false;
      let downloadUrl = '';
      downloadUrl = "http://api.gw.duhongtech.com/sight/sys/codes/generate?token="+
          localStorage.getItem("token");
      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = downloadUrl;
      a.click();
      return false;
    },
    tempdownloadRepCheckReport() {
      this.tempaddeletedialogVisible = false;
      let downloadUrl = '';
      downloadUrl = "http://api.gw.duhongtech.com/sight/sys/codes/tempgen?token="+
          localStorage.getItem("token");
      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = downloadUrl;
      a.click();
      return false;
    },
    downloadRepCheckReportwifi() {
      this.wifiaddeletedialogVisible = false;
      let downloadUrl = '';
      downloadUrl = "http://app.duhongtech.com:9081/sight/sys/codes/generate?token="+
          localStorage.getItem("token");
      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = downloadUrl;
      a.click();
      return false;
    }

    // generated(){
    //   axios({
    //     method:"get",
    //     url:"/sys/codes/generate",
    //     responseType: 'blob',
    //     data:{}
    //   }).then(res=>{
    //     console.log("999999999999")
    //   }).catch(error=>{
    //     console.log("111111111111111111")
    //   });
    // }

  }
}
</script>

<style scoped>

</style>